import { Box, Button, Grid } from "@mui/material";
import FilterChips from "../../../App/Components/Filters/FilterChips";
import SearchFilters from "../../../App/Components/Filters/SearchFilters";
import Modal from "../../../App/Components/Modal/Modal";
import { useFilteredDeleteCandidatesPagingQuery } from "../../../App/Queries/CandidateQueries";
import { useCandidatesFilterStore } from "../../../App/State/Stores/CandidatesPaginationStore";
import CandidatesSearchInput from "../../../ManageCandidates/Components/CandidatesSearchInput/CandidatesSearchInput";
import {
  DeleteCandidatesModalBody,
  DeleteCandidatesModalFooter,
} from "./Components/DeleteCandidatesModalBody";
import { DeleteCandidatesTable } from "./Components/DeleteCandidatesTable";
import { DeleteCandidateStateType } from "./State/DeleteCandidateState";
import { STORAGE_VERSION_DATE } from "../../../App/Utilities/browserStorage";

function SearchAndDelete({
  state: {
    getters: {
      selectedClient,
      isDeleteModalOpen,
      isDeleteCandidatesLoading,
      failedDeletes,
      candidatesToDelete,
      responseMessage,
    },
    setters: { setIsDeleteModalOpen, setCandidatesToDelete },
    effects: { handleDeleteCandidates, handleCloseDeleteModalWithFailedDeletes },
  },
}: {
  state: DeleteCandidateStateType;
}) {
  const key =
    selectedClient && selectedClient.clientId
      ? `delete-candidates-${selectedClient.clientId}-${STORAGE_VERSION_DATE}`
      : `delete-candidates-${STORAGE_VERSION_DATE}`;
  const { search, tags, timeFilter, handleSearchChange, handleTagsChange, handleTimeFilterChange } =
    useCandidatesFilterStore(key);
  const { filterQueryString, isLoading } = useFilteredDeleteCandidatesPagingQuery(selectedClient?.clientId);
  let buttonText = "Delete Candidates";
  if (candidatesToDelete.length > 1) {
    buttonText = `Delete ${candidatesToDelete.length} Candidates`;
  }
  if (candidatesToDelete.length === 1) {
    buttonText = "Delete Candidate";
  }

  return (
    <Grid container>
      <Grid item container xs={12} sx={{ marginBottom: "10px" }}>
        <Grid container item xs={12} sm={12} md={9} spacing={2}>
          <Grid item xs={12} md={4}>
            <CandidatesSearchInput search={search} handleSearchChange={handleSearchChange} />
          </Grid>
          <Grid container item xs={12} md={8} spacing={2}>
            <SearchFilters
              isLoading={isLoading}
              filterQueryString={filterQueryString}
              setTags={handleTagsChange}
              setTimeFilter={handleTimeFilterChange}
              tags={tags}
              timeFilter={timeFilter}
              id="delete-candidates-filter"
              selectedClient={selectedClient}
            />
          </Grid>
        </Grid>
        <Grid container item xs={12} sm={12} md={3} spacing={2} alignItems="center">
          <Button
            data-test="delete-candidates-button"
            color="error"
            variant="contained"
            sx={{ ml: "auto" }}
            disabled={candidatesToDelete.length === 0}
            onClick={() => {
              setIsDeleteModalOpen(true);
            }}
          >
            {buttonText}
          </Button>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ marginBottom: "10px" }}>
        <FilterChips
          timeFilter={timeFilter}
          tags={tags}
          handleTimeFilterChange={handleTimeFilterChange}
          handleTagsChange={handleTagsChange}
        />
      </Grid>
      <Grid item xs={12}>
        <Box sx={{ mb: 0 }}>
          <DeleteCandidatesTable
            selectedClient={selectedClient}
            candidatesToDelete={candidatesToDelete}
            setCandidatesToDelete={setCandidatesToDelete}
          />
          <Modal
            dataTestId="delete-candidate"
            isOpen={isDeleteModalOpen}
            handleCloseModal={() => setIsDeleteModalOpen(false)}
            title="Confirm Delete"
            content={
              <DeleteCandidatesModalBody
                candidatesToDelete={candidatesToDelete}
                failedDeletes={failedDeletes}
                responseMessage={responseMessage}
              />
            }
            footerContent={
              <DeleteCandidatesModalFooter
                failedDeletes={failedDeletes}
                disabled={candidatesToDelete.length === 0 || isDeleteCandidatesLoading}
                onSend={handleDeleteCandidates}
                onClose={handleCloseDeleteModalWithFailedDeletes}
              />
            }
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default SearchAndDelete;
